import { useState } from 'react';
import { motion } from 'framer-motion';
import { SPECIMENS } from './data';

// SPECIMENS — museum-pinned macro grid. Each piece centred on a velvet plinth,
// with hover lifting the lid (ie label slides up). NO tabs.
export default function Specimens() {
  const [active, setActive] = useState(null);
  return (
    <div className="bg-[#0B0A0E] text-white">
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-white/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9B68B] mb-4">— Specimens · current collection</p>
        <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 items-end">
          <h1 className="font-serif text-[48px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">Six pieces, <span className="italic text-[#C9B68B]">on velvet</span>.</h1>
          <p className="font-serif italic text-base lg:text-lg text-white/60 leading-[1.5] max-w-md">All pieces shown have been delivered. They are documented here, with permission, as evidence of work. No piece is repeated.</p>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9B68B]/10">
        {SPECIMENS.map((s, i) => (
          <motion.button key={s.n} onClick={() => setActive(s)} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="group bg-[#0B0A0E] p-8 lg:p-10 text-left relative overflow-hidden" data-testid={`jewel-specimen-${s.n.split('/')[1]}`}>
            <div className="aspect-square overflow-hidden bg-gradient-to-b from-[#15131A] to-[#0B0A0E] mb-5 flex items-center justify-center p-6">
              <img src={s.img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
            </div>
            <p className="font-mono text-[9px] tracking-[0.35em] uppercase text-[#C9B68B]/85" dangerouslySetInnerHTML={{ __html: s.n }} />
            <p className="font-serif text-2xl mt-1.5 leading-tight">{s.name}</p>
            <p className="font-mono text-[10px] text-white/55 mt-2 leading-relaxed" dangerouslySetInnerHTML={{ __html: s.stone }} />
            <div className="border-t border-white/10 mt-4 pt-3 flex justify-between items-baseline">
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#C9B68B]/85">{s.metal}</span>
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#C9B68B] group-hover:underline">Detail →</span>
            </div>
          </motion.button>
        ))}
      </section>

      {/* Modal */}
      {active && (
        <div onClick={() => setActive(null)} className="fixed inset-0 z-50 bg-[#0B0A0E]/95 backdrop-blur-sm flex items-center justify-center p-6 cursor-zoom-out">
          <motion.div onClick={(e) => e.stopPropagation()} initial={{ scale: 0.96, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="bg-[#0B0A0E] border border-[#C9B68B]/25 max-w-5xl w-full grid md:grid-cols-2 max-h-[88vh] overflow-y-auto">
            <div className="aspect-square bg-gradient-to-b from-[#15131A] to-[#0B0A0E] p-12"><img src={active.img} alt="" className="w-full h-full object-cover" /></div>
            <div className="p-10 lg:p-14">
              <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#C9B68B]" dangerouslySetInnerHTML={{ __html: active.n }} />
              <h2 className="font-serif text-3xl lg:text-4xl mt-2">{active.name}</h2>
              <table className="font-mono text-[11px] mt-8 w-full">
                <tbody>
                  {[['Stone', active.stone], ['Metal', active.metal], ['Time at bench', active.months + ' months'], ['Status', 'Delivered'], ['Provenance', 'Single owner, documented'], ['Estimate', active.price]].map(([k, v]) => (
                    <tr key={k} className="border-b border-white/10"><td className="py-3 text-white/45 tracking-[0.2em] uppercase w-32">{k}</td><td className="py-3" dangerouslySetInnerHTML={{ __html: v }} /></tr>
                  ))}
                </tbody>
              </table>
              <button onClick={() => setActive(null)} className="mt-8 font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9B68B] hover:text-white">Close ✕</button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}
